const tv = [
  {
    path: '/tv/binding',
    meta: {requireAuth: false, title: '选择机构'},
    component: () => import('@/views/tv/orgBinding.vue')
  },
  {
    path: '/tv/bindSearch',
    meta: {requireAuth: false, title: '搜索'},
    component: () => import('@/views/tv/orgBindingSearch.vue')
  },
  {
    path: '/tv/sign',
    meta: {requireAuth: true, title: '签到'},
    component: () => import('@/views/tv/sign.vue')
  }
]
export {tv}
